var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncidentPopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_879_26081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8761 2.67202C14.5871 2.16412 14.1688 1.74181 13.6636 1.44804C13.1584 1.15427 12.5845 0.999512 12.0001 0.999512C11.4157 0.999512 10.8418 1.15427 10.3366 1.44804C9.83148 1.74181 9.41312 2.16412 9.12412 2.67202L0.414118 18.19C0.137535 18.677 -0.00544948 19.2284 -0.00035685 19.7884C0.00473578 20.3484 0.157725 20.8972 0.443118 21.379C0.732702 21.8762 1.14854 22.2879 1.64851 22.5726C2.14848 22.8573 2.71481 23.0047 3.29012 23H20.7101C21.2854 23.0047 21.8518 22.8573 22.3517 22.5726C22.8517 22.2879 23.2675 21.8762 23.5571 21.379C23.8425 20.8972 23.9955 20.3484 24.0006 19.7884C24.0057 19.2284 23.8627 18.677 23.5861 18.19L14.8761 2.67202ZM21.8311 20.372C21.716 20.566 21.5517 20.7262 21.3549 20.8365C21.1581 20.9467 20.9357 21.0031 20.7101 21H3.29012C3.06426 21.0028 2.84166 20.946 2.64482 20.8352C2.44798 20.7244 2.28389 20.5636 2.16912 20.369C2.06033 20.1882 2.00194 19.9815 2 19.7705C1.99807 19.5595 2.05266 19.3518 2.15812 19.169L10.8681 3.65002C10.9915 3.46249 11.1595 3.30855 11.3571 3.20203C11.5547 3.0955 11.7756 3.03974 12.0001 3.03974C12.2246 3.03974 12.4455 3.0955 12.6431 3.20203C12.8407 3.30855 13.0087 3.46249 13.1321 3.65002L21.8421 19.168C21.9478 19.3509 22.0025 19.5588 22.0005 19.77C21.9986 19.9812 21.9401 20.1881 21.8311 20.369V20.372Z",
    fill: "#776F6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7C11.7348 7 11.4804 7.10536 11.2929 7.29289C11.1054 7.48043 11 7.73478 11 8V14C11 14.2652 11.1054 14.5196 11.2929 14.7071C11.4804 14.8946 11.7348 15 12 15C12.2652 15 12.5196 14.8946 12.7071 14.7071C12.8946 14.5196 13 14.2652 13 14V8C13 7.73478 12.8946 7.48043 12.7071 7.29289C12.5196 7.10536 12.2652 7 12 7Z",
    fill: "#776F6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19C12.5523 19 13 18.5523 13 18C13 17.4477 12.5523 17 12 17C11.4477 17 11 17.4477 11 18C11 18.5523 11.4477 19 12 19Z",
    fill: "#776F6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_879_26081"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncidentPopup);
export default __webpack_public_path__ + "static/media/incident_popup.4eb8fd1ceebf3a790c837f5f937079e5.svg";
export { ForwardRef as ReactComponent };